import React from 'react'
import workImg from "../assets/workImg.jpeg"
import realEstate from "../assets/realestate.jpg"
import gensan from "../assets/gensan.PNG"
import counter from "../assets/counter.jpg"
import todo from "../assets/todo.png"
import calcu from "../assets/calcu.jpg"

const Work = () => {
  return (
    <div name="work" className="w-full md:h-screen text-gray-300 bg-[#0a192f]">
        <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
            <div className='pb-8'>
                <p className="text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600">Works</p>
                <p className="py-6">Take a look at my works</p>
            </div>
{/* Container */}
            <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>   
{/* Grid-items */}                         
                <div style={{backgroundImage:`url(${gensan  })`}} className= "shadow-lg shadow[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div ">
                   
                   {/* Hover Effects */}
                    <div className="opacity-0 group-hover:opacity-100">
                        <span className='text-2xl font-bold text-white tracking-wider'>
Local web
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">Demo</button>
                            </a>
                            <a href="/">
                                <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">Code</button>
                            </a>
                        </div>
                    </div>
                </div>
                {/* Grid-items */}                         
                <div style={{backgroundImage:`url(${counter})`}} className= "shadow-lg shadow[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div ">
                   
                   {/* Hover Effects */}
                    <div className="opacity-0 group-hover:opacity-100">
                        <span className='text-2xl font-bold text-white tracking-wider'>
React Counter
                           </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">Demo</button>
                            </a>
                            <a href="/">
                                <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">Code</button>
                            </a>
                        </div>
                    </div>
                </div>
                {/* Grid-items */}                         
                <div style={{backgroundImage:`url(${realEstate})`}} className= "shadow-lg shadow[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div ">
                   
                   {/* Hover Effects */}
                    <div className="opacity-0 group-hover:opacity-100">
                        <span className='text-2xl font-bold text-white tracking-wider'>
React JS Application
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">Demo</button>
                            </a>
                            <a href="/">
                                <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">Code</button>
                            </a>
                        </div>
                    </div>
                </div>
                {/* Grid-items */}                         
                <div style={{backgroundImage:`url(${todo})`}} className= "shadow-lg shadow[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div ">
                   
                   {/* Hover Effects */}
                    <div className="opacity-0 group-hover:opacity-100">
                        <span className='text-2xl font-bold text-white tracking-wider'>
To Do Task
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">Demo</button>
                            </a>
                            <a href="/">
                                <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">Code</button>
                            </a>
                        </div>
                    </div>
                </div>
                {/* Grid-items */}                         
                <div style={{backgroundImage:`url(${workImg})`}} className= "shadow-lg shadow[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div ">
                   
                   {/* Hover Effects */}
                    <div className="opacity-0 group-hover:opacity-100">
                        <span className='text-2xl font-bold text-white tracking-wider'>
Real Estate Application
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">Demo</button>
                            </a>
                            <a href="/">
                                <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">Code</button>
                            </a>
                        </div>
                    </div>
                </div>
                {/* Grid-items */}                         
                <div style={{backgroundImage:`url(${calcu})`}} className= "shadow-lg shadow[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div ">
                   
                   {/* Hover Effects */}
                    <div className="opacity-0 group-hover:opacity-100">
                        <span className='text-2xl font-bold text-white tracking-wider'>
Simple calculator
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">Demo</button>
                            </a>
                            <a href="/">
                                <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">Code</button>
                            </a>
                        </div>
                    </div>
                </div>
                
            </div>

                
        </div>
        
    </div>
  )
}

export default Work